"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _table = _interopRequireDefault(require("../../../../../core/table"));
var _input = _interopRequireDefault(require("../../../../../core/input"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", null, "Day"), /*#__PURE__*/_react.default.createElement("th", null, "Race"), /*#__PURE__*/_react.default.createElement("th", null, "Bib"), /*#__PURE__*/_react.default.createElement("th", null, "Name")));
class EntriesSelector extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onToggleSelected", (id, selected) => {
      this.props.onChangeSelectedEntryIDs(selected ? this.props.selectedEntryIDs.concat([id]) : this.props.selectedEntryIDs.filter(i => i !== id));
    });
    _defineProperty(this, "_isSelected", id => {
      return this.props.selectedEntryIDs.indexOf(id) !== -1;
    });
  }
  render() {
    // only allow user to select from entries that match the status
    const entries = this.props.entry.matchedEntries.filter(entry => {
      return entry.entryStatusRef === this.props.entry.entryStatusRef;
    });
    return /*#__PURE__*/_react.default.createElement(_table.default, null, _ref, /*#__PURE__*/_react.default.createElement("tbody", null, entries.map(entry => /*#__PURE__*/_react.default.createElement("tr", {
      key: entry.id
    }, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      checked: this._isSelected(entry.id),
      onChange: this._onToggleSelected.bind(this, entry.id)
    })), /*#__PURE__*/_react.default.createElement("td", null, (0, _occasion.default)(entry.race.competitionDay.dayDate, 'ddd')), /*#__PURE__*/_react.default.createElement("td", null, entry.race.raceName), /*#__PURE__*/_react.default.createElement("td", null, entry.startListBib), /*#__PURE__*/_react.default.createElement("td", null, entry.bibName)))));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}
_defineProperty(EntriesSelector, "partialQueries", {
  Entry: {
    entryStatusRef: true,
    matchedEntries: {
      id: true,
      bibNumber: true,
      startListBib: true,
      bibName: true,
      rankingDivisionDescription: true,
      classDescription: true,
      entryStatusRef: true,
      race: {
        competitionDay: {
          dayDate: true
        },
        raceName: true
      }
    }
  }
});
var _default = exports.default = EntriesSelector;